var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"shareTip",on:{"click":_vm.hide}},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/786cf372b62602dd0727dd2c446909d0.png","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }